import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_DELETE, llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { TratamientoDeParametroParaURI } from '../../Varios';

export const function_ABM_ART_Articulos_CodigosBarra_Listar = async (Where) => {
    const NombreFuncion = "function_ABM_ART_Articulos_CodigosBarra_Listar"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos_CodigosBarra/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(Where));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_CodigosBarra_Leer = async (CodigoArticulo, CodigoPresentacion, CodigoTamano, CodigoUnidadMedida, NumeroSerie) => {
    const NombreFuncion = "function_ABM_ART_Articulos_CodigosBarra_Leer"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos_CodigosBarra/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo) + "/" +
            await TratamientoDeParametroParaURI(CodigoPresentacion) + "/" +
            await TratamientoDeParametroParaURI(CodigoTamano) + "/" +
            await TratamientoDeParametroParaURI(CodigoUnidadMedida) + "/" +
            await TratamientoDeParametroParaURI(NumeroSerie));

        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_CodigosBarra_LeerPorCodigoBarras = async (CodigoBarras) => {
    const NombreFuncion = "function_ABM_ART_Articulos_CodigosBarra_LeerPorCodigoBarras"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos_CodigosBarra/LeerPorCodigoBarras/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoBarras));

        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_CodigosBarra_LeerPorCodigoBarrasProv = async (CodigoBarrasProv) => {
    const NombreFuncion = "function_ABM_ART_Articulos_CodigosBarra_LeerPorCodigoBarrasProv"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos_CodigosBarra/LeerPorCodigoBarrasProv/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoBarrasProv));

        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_CodigosBarra_LeerPorCodigoBarrasInt = async (CodigoBarrasInt) => {
    const NombreFuncion = "function_ABM_ART_Articulos_CodigosBarra_LeerPorCodigoBarrasInt"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos_CodigosBarra/LeerPorCodigoBarrasInt/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoBarrasInt));

        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_CodigosBarra_Insertar = async (Objeto) => {
    const NombreFuncion = "function_ABM_ART_Articulos_CodigosBarra_Insertar";

    try {
        const objetoResult = await llamadaAPI_POST("ABM_ART_Articulos_CodigosBarra/InsertarCompleto", Objeto);
        return objetoResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ART_Articulos_CodigosBarra_Modificar = async (Objeto) => {
    const NombreFuncion = "function_ABM_ART_Articulos_CodigosBarra_Modificar";

    try {
        await llamadaAPI_PUT("ABM_ART_Articulos_CodigosBarra/ModificarCompleto", Objeto);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ART_Articulos_CodigosBarra_Generar_JSON = async (CodigoArticulo, CodigoPresentacion, CodigoTamano, CodigoUnidadMedida,
    NumeroSerie, CodigoBarrasInt, CodigoBarrasProv, CodigoBarras, Peso, Largo, Ancho, Alto,
    VentaSuspendida, VentaManualPredeterminada, TaraEnvase) => {
    const NombreFuncion = "function_ABM_ART_Articulos_CodigosBarra_Generar_JSON";

    try {
        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            CodigoArticulo: CodigoArticulo,
            CodigoPresentacion: CodigoPresentacion,
            CodigoTamano: CodigoTamano,
            CodigoUnidadMedida: CodigoUnidadMedida,
            NumeroSerie: NumeroSerie,
            CodigoBarrasInt: CodigoBarrasInt,
            CodigoBarrasProv: CodigoBarrasProv,
            CodigoBarras: CodigoBarras,
            Peso: Peso,
            Largo: Largo,
            Ancho: Ancho,
            Alto: Alto,
            VentaSuspendida: VentaSuspendida,
            VentaManualPredeterminada: VentaManualPredeterminada,
            TaraEnvase: TaraEnvase
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ART_Articulos_CodigosBarra_Eliminar = async (CodigoArticulo, CodigoPresentacion, CodigoTamano, CodigoUnidadMedida, NumeroSerie) => {
    const NombreFuncion = "function_ABM_ART_Articulos_CodigosBarra_Eliminar"

    try {
        const resulData = await llamadaAPI_DELETE("ABM_ART_Articulos_CodigosBarra/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo) + "/" +
            await TratamientoDeParametroParaURI(CodigoPresentacion) + "/" +
            await TratamientoDeParametroParaURI(CodigoTamano) + "/" +
            await TratamientoDeParametroParaURI(CodigoUnidadMedida) + "/" +
            await TratamientoDeParametroParaURI(NumeroSerie));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};